import {
  Box,
  Button,
  createStyles,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import SettingsIcon from "@material-ui/icons/Settings";
import FilterListIcon from "@material-ui/icons/FilterList";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Delete as DeleteIcon } from "@material-ui/icons";

import HomeHeaderMenu from "../../Home/HomeHeaderMenu";
import MaterialTable, { MTableBodyRow, MTableToolbar } from "material-table";
import { useHistory } from "react-router";
import useDebounce from "../../../Components/debounce";
import DataService from "../../../Service";
import ErrorIcon from "@material-ui/icons/Error";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { TooltipWrapper } from "../../../Common/Utils/common_utils";
import ExportSelector from "../Organization/ManageInfo/ExportSelector";
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      background: "#B4B4B40D",
      height: "100%",
    },

    heading: {
      // fontSize: "18px",
      color: "#EF7000",
      fontWeight: "bold",
    },
    btn: {
      width: "116px",
      height: "100%",
      fontSize: 12,
      textTransform: "capitalize",
      borderRadius: 2,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: "#EF7000",
      color: "white",
    },
    filterBtn: {
      width: "116px",
      height: "100%",
      fontSize: 12,
      textTransform: "capitalize",
      borderRadius: 2,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: "#077f83",
      color: "white",
    },
    toggleBtn: {
      // fontSize: "18px",
      // fontFamily: "Open Sans",
      backgroundColor: "#fff",
      color: "#4089FC",
      border: "1px solid #00808080",
      padding: "5px 10px",
      borderRadius: "5px 0px 0px 5px",
      cursor: "pointer",
      "& + $toggleBtn": {
        borderRadius: "0px 5px 5px 0px",
      },

      "&.active": {
        backgroundColor: "#4089FC",
        color: "#fff",
      },
    },
    input: {
      height: "100%",
      lineHeight: "100%",
      width: "504px",
      border: "1px solid #70707040",
      borderRadius: 2,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      paddingTop: "0.25rem",
    },
    whiteBg: {
      boxShadow:
        "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
      background: "white",

      //  boxShadow: "0px 3px 10px #232323",
      padding: "50px",
      paddingRight: "22px",
      paddingLeft: "22px",
      width: "93%",
      margin: "0px auto",
    },
    iconBtn: {
      width: "27px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#3B86FF",
      color: "#fff",
      borderRadius: "4px",
      cursor: "pointer",
      marginLeft: 20,
    },
    miTable: {
      "& .MuiToolbar-root": {
        "& .material-icons": {
          color: theme.palette.secondary.main,
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-body": {
          // padding: "10px 16px",
          lineHeight: "1.50",
          "& .MuiIconButton-root": {
            padding: "0px 16px",
          },
        },
      },
    },
  })
);
function FinanceAdminHome() {
  const classes = useStyles();

  const history = useHistory();

  const [hoveringOver, setHoveringOver] = useState("");

  const handleRowHover = (event, propsData) =>
    setHoveringOver(propsData.data.tableData.id);
  const handleRowHoverLeave = (event, propsData) => setHoveringOver("");

  const [, setForceUpdate] = useState(0);
  const forceUpdate = () => setForceUpdate((old) => old + 1);

  const handleEditClick = (event, rowData) => {
    rowData.tableData.editing = "delete";
    forceUpdate();
  };
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTextSelect, handleSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  const [activeBtnText, setActiveBtnText] = useState("Client");
  const [pageRenderFlag, setPageRenderFlag] = useState(false);

  const getData = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 10,
      search_keyword: debouncedSearchText || null,
      // invoice_for:"supplier"
      invoice_for: activeBtnText.toLowerCase(),
    };
    DataService.getDirectData(`/invoices`, params)
      .then((response) => {
        if (response.invoices) {
          console.log(
            "response.invoices.total_count :>> ",
            response.total_count
          );
          let listData = response["invoices"];
          setApiData(listData);
          setTotalCount(response.total_count);
        }
        setLoading(false);
      })

      .catch((err) => {});
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, [page, pageSize, debouncedSearchText, activeBtnText]);
  const statusMapButtons = {
    Paid: "button-positive",
    "Invoice to be raised": "button-black",
    "Near due": "button-warning",
    "Past due": "button-negative",
  };
  const PoCapitaliser = (inp) => {
    if (inp?.toLowerCase().includes("po")) {
      const separated = inp?.toLowerCase().split(" ");
      console.log(separated, inp, "input");
      return separated
        ?.map((el) => {
          if (el === "po") {
            return "PO";
          } else {
            return el;
          }
        })
        .join(" ");
    } else {
      return inp;
    }
  };
  const columns = [
    {
      field: "invoice_number",
      title: "Invoice number",
      headerStyle: { paddingLeft: 0 },
      cellStyle: { paddingLeft: 0 },
    },
    {
      field: "organisation_name",
      headerStyle: { paddingLeft: 0 },
      cellStyle: { paddingLeft: 0 },
      title: "Organization name",
    },
    { field: "assignment_name", title: "Assignment name" },
    {
      field: "amount",
      title: "Total amount",

      render: (rowData) => (
        <div
        // className="center"
        // style={{ paddingLeft: "16px",display:"flex",gap:"1rem" }}
        >
          <span style={{ textAlign: "left" }}>{rowData.amount}</span>
        </div>
      ),
    },
    { field: "invoice_name", title: "Tranche number" },
    { field: "invoice_amount", title: "Tranche amount" },
    { field: "due_date", title: "Due date" },
    { field: "invoice_date", title: "Invoice date" },
    { field: "promised_date", title: "Promised date", hidden: true },
    { field: "paid_date", title: "Paid date", hidden: true },
    {
      field: "payment_terms",
      title: "Payment terms",
      cellStyle: {
        // textAlign: "justify",
        width: "80%",
      },
      hidden: true,
    },
    // { field: "invoice_notes_type", title: "Invoice Notes" },
    {
      // field: "invoice_notes_type",
      title: "Invoice notes",
      hidden: true,
      cellStyle: {
        textAlign: "center",
        width: "15%",
      },
      headerStyle: { textAlign: "center" },
      render: (rowData) =>
        rowData.invoice_notes_type === "action_required" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
            <ErrorIcon style={{ color: "#DE2529" }} />
            <span>
              {rowData.invoice_notes_type === "action_required" &&
                "Action required"}
            </span>
          </div>
        ) : (
          rowData.invoice_notes_type === "info_only" && (
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <ErrorIcon style={{ color: "#FBBD08" }} />
              <span>
                {rowData.invoice_notes_type === "info_only" && "Info only"}
              </span>
            </div>
          )
        ),
    },
    {
      field: "status",
      title: "Status",
      render: (rowData) => {
        return PoCapitaliser(rowData.status);
      },
    },
    // render: (rowData) => {
    //   return hoveringOver !== "" && rowData.tableData.id === hoveringOver ? (
    //     <Button
    //       // color="primary"
    //       variant="contained"
    //       disableElevation
    //       onClick={() =>
    //         history.push(`/FinanceAdminHome/invoiceDetails/${rowData.id}`)
    //       }
    //       className={classes.btn}
    //       style={{
    //         width: 105,
    //         height: 26,
    //         borderRadius: 1,
    //         fontSize: 12,
    //         backgroundColor: "#3B86FF",
    //       }}
    //     >
    //       View details
    //     </Button>
    //   ) : (
    //     <Button
    //       size="small"
    //       className={statusMapButtons[rowData.status]}
    //       // variant="outlined"
    //       style={{ textTransform: "initial" }}
    //     >
    //       <b>{rowData.status}</b>
    //     </Button>
    //   );
    // },
  ];

  const options = {
    headerStyle: { textAlign: "left", fontWeight: "bold", fontSize: 14 },
    cellStyle: { textAlign: "left", fontSize: 14 },
    actionsColumnIndex: -1,
    toolbar: false,
    search: false,
    sorting: false,
    showTitle: false,
    draggable: false,
    pageSize: 10,
    exportButton: {
      csv: true,
      pdf: true,
    },
  };

  return (
    <div className={classes.root}>
      <HomeHeaderMenu title="Finance Admin" />
      <section style={{ marginTop: "36px" }}>
        <Grid
          style={{}}
          className={classes.whiteBg}
          container
          direction="row"
          // alignItems="center"
          // justify="center"
          justifyContent="center"
        >
          <Grid container item xs={11}>
            <Grid container xs={12} alignItems="">
              {/* <Typography variant="h6" className={classes.heading}>
                  Invoices
                </Typography> */}
              {/* <Grid item xs={1}>
                <Typography variant="h6" className={classes.heading}>
                  Invoices
                </Typography>
              </Grid> */}
              <Grid container item xs={12} justify="center">
                {/* search bar container */}
                <Typography variant="h2" className={classes.heading}>
                  Invoices
                </Typography>
                <Box height="32px" display="flex" ml="45px">
                  <Button
                    color="secondary"
                    variant="contained"
                    disableElevation
                    className={classes.btn}
                  >
                    All
                  </Button>
                  <InputBase
                    placeholder="Search by Name, ID or Email"
                    className={classes.input}
                    value={searchTextSelect}
                    onChange={(e) => handleSearchText(e.target.value)}
                    startAdornment={
                      <InputAdornment
                        position="start"
                        style={{ marginLeft: "10px", marginRight: "8px" }}
                      >
                        <SearchIcon
                          style={{
                            color: "#70707040",
                            marginBottom: "0.05rem",
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                </Box>

                {/* buttons container */}
                <Box display="flex" height="32px">
                  {/* <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    className={classes.filterBtn}
                    startIcon={<FilterListIcon />}
                    style={{
                      width: "83px",
                      borderRadius: 2,
                      marginLeft: "20px",
                    }}
                  >
                    filter
                  </Button> */}

                  {/* <Button
                    color="secondary"
                    variant="contained"
                    disableElevation
                    className={classes.btn}
                    startIcon={<SettingsIcon style={{ cursor: "pointer" }} />}
                    style={{
                      width: "104px",
                      borderRadius: 2,
                      marginLeft: "6px",
                    }}
                  >
                    Customize
                  </Button> */}

                  {/* <div className={classes.iconBtn}>PDF</div>

                  <div className={classes.iconBtn}>
                    <GetAppIcon />
                  </div> */}
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              style={{ marginTop: "32px" }}
              className={classes.miTable}
            >
              <Grid item xs="12">
                <Box mb={3}>
                  <Box
                    component="span"
                    className={classes.toggleBtn}
                    style={{
                      backgroundColor:
                        activeBtnText === "Client" ? "#008080" : "#fff",
                      color: activeBtnText == "Client" ? "#fff" : "#00808080",
                    }}
                    onClick={() => setActiveBtnText("Client")}
                  >
                    Client
                  </Box>
                  <Box
                    component="span"
                    className={classes.toggleBtn}
                    style={{
                      backgroundColor:
                        activeBtnText === "Supplier" ? "#008080" : "#fff",
                      color: activeBtnText == "Supplier" ? "#fff" : "#00808080",
                    }}
                    onClick={() => setActiveBtnText("Supplier")}
                  >
                    Supplier
                  </Box>
                  {/* {accessArray?.tabs?.includes('Client') ? <Box component="span" className={classes.toggleBtn} style={{ backgroundColor: activeBtnText === "Client" ? "#008080" : "#fff", color: activeBtnText == "Client" ? "#fff" : "#00808080" }} onClick={() => setActiveBtnText('Client')}>Client</Box> : null}
                    {accessArray?.tabs?.includes('Supplier') ? <Box component="span" className={classes.toggleBtn} style={{ backgroundColor: activeBtnText === "Supplier" ? "#008080" : "#fff", color: activeBtnText == "Supplier" ? "#fff" : "#00808080" }} onClick={() => setActiveBtnText('Supplier')}>Supplier</Box> : null} */}
                </Box>
              </Grid>
              {
                <MaterialTable
                  title={""}
                  style={{ width: "100%", padding: "20px" }}
                  // style={{ boxShadow: "none" }}
                  // options={options}
                  columns={columns}
                  isLoading={loading}
                  options={{
                    actionsColumnIndex: -1,
                    // searchFieldAlignment: "right",

                    columnsButton: true,
                    // exportButton: true,
                    exportButton: false,
                    // headerStyle: {
                    //   textAlign: "left",
                    //   fontWeight: "bold",
                    //   fontSize: 14,
                    // },
                    cellStyle: { textAlign: "left", fontSize: 14 },
                    search: false,
                    pageSize: pageSize,
                    total: totalCount,
                    exportFileName: "Finance-admin",
                    pageSizeOptions: [20, 50, 75, 100],
                    headerStyle: {
                      position: "sticky",
                      top: "0",
                      textAlign: "left",
                      fontWeight: "bold",
                      fontSize: 14,
                    },
                    maxBodyHeight: "600px",
                  }}
                  totalCount={totalCount}
                  page={page}
                  onChangePage={(page) => {
                    setPage(page);
                  }}
                  onChangeRowsPerPage={(pageSize) => {
                    setPageSize(pageSize);
                  }}
                  actions={[
                    {
                      icon: () => {
                        const params = {
                          page: page + 1 || 1,
                          count_per_page: totalCount || 10,
                          search_keyword: debouncedSearchText || null,
                          // invoice_for:"supplier"
                          invoice_for: activeBtnText.toLowerCase(),
                        };

                        let url = "/invoices";

                        return (
                          <ExportSelector
                            params={params}
                            columns={columns}
                            url={url}
                            downloadKey="invoices"
                            fileName={"Finance details " + activeBtnText}
                          />
                        );
                      },
                      isFreeAction: true,
                    },
                    {
                      icon: () => <VisibilityIcon fontSize="small" />,
                      iconProps: {
                        style: { fontSize: "14px", color: "green" },
                      },
                      tooltip: <TooltipWrapper text="View" />,
                      onClick: (event, rowData) => {
                        history.push(
                          `/FinanceAdminHome/invoiceDetails/${rowData.id}}`
                        );
                      },
                    },
                  ]}
                  data={apiData}
                  onMouseEnter={(e) => console.log(e)}
                  localization={{
                    toolbar: {
                      exportName: "Download as CSV",
                      exportAriaLabel: "Download as CSV",
                      exportTitle: <TooltipWrapper text="Download as CSV" />,
                      showColumnsTitle: <TooltipWrapper text="Show columns" />,
                      showColumnsAriaLabel: "Show columns",
                    },
                  }}
                />
              }
            </Grid>
          </Grid>
        </Grid>
      </section>
    </div>
  );
}

export default FinanceAdminHome;
